export default __webpack_public_path__ + "static/media/hepatology.d578e9ab.jpg";